/*
 * Copyright (c) 2018 by Filestack.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as tslib_1 from "tslib";
import throatImpl from './throat';
import * as t from 'tcomb-validation';
export var throat = throatImpl;
/**
 * Resolve cdn url based on handle type
 *
 * @private
 * @param session session object
 * @param handle file handle (hash, src://alias, url)
 */
export var resolveCdnUrl = function (session, handle) {
    var cdnURL = session.urls.cdnUrl;
    if (handle && (handle.indexOf('src:') === 0 || handle.indexOf('http') === 0)) {
        if (!session.apikey) {
            throw new Error('Api key is required when storage alias is provided');
        }
        // apikey is required for alias or external sources call
        return cdnURL + "/" + session.apikey;
    }
    return cdnURL;
};
export var resolveHost = function (hosts, cname) {
    var result = hosts;
    if (cname) {
        var hosts_1 = /filestackapi.com|filestackcontent.com/i;
        Object.keys(hosts_1).forEach(function (key) {
            result[key] = hosts_1[key].replace(hosts_1, cname);
        });
    }
    return result;
};
/**
 * Check config options
 *
 * @private
 * @param name
 * @param allowed
 * @param options
 */
export var checkOptions = function (name, allowed, options) {
    if (options === void 0) { options = {}; }
    var keys = Object.keys(options);
    var allowedNames = allowed.map(function (a) { return a.name; });
    var namesFormatted = allowedNames.join(', ');
    keys.forEach(function (key) {
        if (allowedNames.indexOf(key) < 0) {
            throw new Error(key + " is not a valid option for " + name + ". Valid options are: " + namesFormatted);
        }
    });
    allowed.forEach(function (obj) {
        var value = options[obj.name];
        if (obj.name === 'location' && typeof value === 'string') {
            value = value.toLowerCase();
        }
        if (value !== undefined) {
            var result = t.validate(value, obj.type);
            if (!result.isValid()) {
                var error = result.firstError();
                if (error && error.message) {
                    throw new Error(error.message);
                }
            }
        }
    });
    return keys;
};
/**
 * Removes empty options from object
 *
 * @private
 * @param obj
 */
export var removeEmpty = function (obj) {
    var newObj = tslib_1.__assign({}, obj);
    Object.keys(newObj).forEach(function (k) { return (!newObj[k] && newObj[k] !== undefined) && delete newObj[k]; });
    return newObj;
};
/**
 *
 * @private
 * @param fn
 * @param interval
 * @param callFirst
 */
export var throttle = function throttle(fn, interval, callFirst) {
    var wait = false;
    var callNow = false;
    /* istanbul ignore next */
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        callNow = !!callFirst && !wait;
        var context = this;
        if (!wait) {
            wait = true;
            setTimeout(function () {
                wait = false;
                if (!callFirst) {
                    return fn.apply(context, args);
                }
            }, interval);
        }
        if (callNow) {
            callNow = false;
            return fn.apply(this, arguments);
        }
    };
};
/**
 *
 * @private
 * @param start
 * @param stop
 * @param step
 */
export var range = function (start, stop, step) {
    if (step === void 0) { step = 1; }
    var toReturn = [];
    for (; start < stop; start += step) {
        toReturn.push(start);
    }
    return toReturn;
};
